<template>
	<div>
		<div class="barcode-info-scan">
			<img
				src="https://cdn.orderonline.id/img/barcode-scanner.gif"
				class="w-100"
				alt="Ostock"
			/>
		</div>
		<div class="page-barcode-scanner">
			<!-- Menu -->
			<div class="d-flex align-items-center justify-content-end mt-2">
				<div
					class="d-flex align-items-center text-primary  text-sm"
				>
					<span class="mr-1">
						{{
							$tc('global.orders', submissions.length, {
								count: submissions.length,
							})
						}}
					</span>
					<span>{{ $t('Scanned') }}</span>
				</div>
			</div>
			<div class="d-flex align-items-end flex-wrap mb-3">
				<div class="mr-2">
					<label>Return Status</label>
					<select
						class="form-control form-control-sm"
						v-tooltip="'Change Status to'"
						v-model="status"
						@input="onStatusSelected"
					>
						<option value="completed">Completed</option>
						<option value="broken">Broken</option>
						<!-- <option value="lost">Lost</option> -->
					</select>
				</div>
				<div class="mr-2 flex-grow-1">
					<input
						class="input form-control form-control-sm"
						ref="input"
						id="keyword-input"
						autofocus
						v-focus
						v-model="q"
						:disabled="isUpdating"
						@click="selectText"
						@keyup.enter="onKeywordInput"
					/>
				</div>
				<div>
					<button
						class="btn btn-primary btn-sm"
						:class="{ 'is-loading': isUpdating }"
						@click="updateOrder"
					>
						Update
					</button>
				</div>
			</div>

			<div v-if="status === 'broken'">
				<div class="form-group">
					<label>Link Bukti</label>
					<input
						type="text"
						name="evidence_url"
						class="form-control"
						placeholder="Masukkan link bukti"
						v-model="evidenceUrl"
						@input="validateForm"
					>
					<small class="text-danger" v-if="errorMessages.evidenceUrl">{{ errorMessages.evidenceUrl }}</small>
				</div>
			</div>

			<div v-if="errorMessage" class="alert alert-danger mb-3">
				{{ errorMessage }}
			</div>

			<div class="alert alert-info mb-3">
				{{ information }}
			</div>

			<!-- Main Table -->
			<div class="barcode-list table-responsive">
				<table class="barcode-list-table table table-striped table-hover">
					<thead>
						<tr>
							<th>
								{{ $t('Order ID') }}
							</th>
							<th>
								{{ $t('Receipt Number') }}
							</th>
							<th>
								{{ $t('Courier') }}
							</th>
							<th>
								{{ $t('Name') }}
							</th>
							<th>
								{{ $t('Return Status') }}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(submission, index) in submissions" :key="index">
							<td>
								<div class="barcode-scanner">
									<span>
										{{ submission.order_id }}
									</span>
								</div>
							</td>
							<td>
								<div class="barcode-scanner">
									<span>
										{{ submission.shipping.receipt_number }}
									</span>
								</div>
							</td>
							<td>
								<div class="barcode-scanner">
									<span>
										{{ submission.shipping.courier }}
									</span>
								</div>
							</td>
							<td>
								<div class="barcode-scanner">
									<span>
										{{ submission.customer_data.name }}
									</span>
								</div>
							</td>
							<td>
								<div class="barcode-scanner">
									<span>
										{{ toTitleCase(submission.shipping.return_status) }}
									</span>
								</div>
							</td>
						</tr>
					</tbody>
				</table>

				<!-- Table Loader -->
				<div class="table-fetch-status" v-if="isUpdating">
					<div class="is-loading large dark m-auto"></div>
				</div>

				<!-- Table Empty -->
				<div
					class="list-empty b-0"
					v-if="submissions.length === 0 && isUpdating === false"
				>
					<span>{{ $t('Start Scanning') }}</span>
				</div>

				<div
					class="table-vertical-scroll hidden-sm"
					id="orders-list-vertical-scroll"
				>
					<div
						class="table-vertical-scroll-content"
						id="orders-list-vertical-scroll-content"
					></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import '@/lib/typedef';
import {
	delay,
	formatMoney,
	getAxiosErrorMessage,
	toTitleCase,
	isUrlValid,
} from '@/lib/helper';
import { updateReturnStatus } from '@/api/submissions';

export default {
	name: 'NewBarcodeScanner',
	props: {
		show: {
			type: Boolean,
			default: false,
		},
	},
	components: {},
	data() {
		return {
			status: 'completed',
			isUpdating: false,
			isAll: false,
			submissions: [],
			q: '',
			code: '',
			type: 'order_id',
			selected: [],
			isValidateError: {
				tier: false,
			},
			isReading: false,
			evidenceUrl: '',
			errorMessages: {
				evidenceUrl: '',
			},
			errorMessage: '',
			isValid: true,
		};
	},
	methods: {
		...mapActions({
			fetchUser: 'fetchUser',
		}),

		toTitleCase,

		// Retrun all string with capitalize
		formatMoney(val) {
			return formatMoney(val);
		},

		selectText() {
			this.$refs.input.select();
		},

		onKeywordInput() {
			delay(() => {
				if (this.q && this.q.trim() !== '') {
					this.updateOrder();
				}
			}, 500);
		},

		validateUrl() {
			this.isValid = isUrlValid(this.evidenceUrl);
		},

		validateForm() {
			let isError = false;
			this.isValid = true;

			this.validateUrl();

			if (this.status === 'broken' && this.evidenceUrl === '') {
				this.errorMessages.evidenceUrl = 'Upload bukti, lalu masukkan linknya ke form';
				isError = true;
			} else if (this.status === 'broken' && !this.isValid) {
				this.errorMessages.evidenceUrl = 'URL tidak valid';
				isError = true;
			} else {
				this.errorMessages.evidenceUrl = '';
			}

			return isError;
		},

		// Fetch contact data using vuex on contact module
		updateOrder() {
			if (this.q === '') {
				this.setFocus();
				return;
			}
			if (this.isUpdating) return;

			const isError = this.validateForm();
			if (isError) {
				return;
			}

			this.isUpdating = true;
			const params = this.fetchParams;
			const callback = (response) => {
				const updatedSubmission = response.data;
				if (updatedSubmission) {
					const submissionIndex = this.submissions.findIndex(
						curr => curr.order_id === updatedSubmission.order_id,
					);
					if (submissionIndex === -1) {
						this.submissions.unshift(updatedSubmission);
						this.$emit('increment');
					}
				}
				this.isUpdating = false;
				this.clear();
				this.setFocus();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.errorMessage = message;
				this.isUpdating = false;
				// this.clear();
				this.code = '';
				this.setFocus();
			};
			updateReturnStatus(params, callback, errorCallback);
		},

		clear() {
			this.q = '';
			this.code = '';
			this.evidenceUrl = '';
			this.errorMessage = '';
		},

		fetchData() {
			//
		},

		init() {
			this.initBarcodeListener();
		},

		onUserLoaded() {
			this.init();
		},

		setFocus() {
			const input = document.getElementById('keyword-input');
			if (input) {
				input.focus();
			}
		},

		onTypeSelected() {
			this.setFocus();
		},

		onStatusSelected() {
			this.setFocus();
		},

		onBarcodeScan(e) {
			// usually scanners throw an 'Enter' key at the end of read
			if (e.key === 'Enter') {
				this.q = this.code;
				this.updateOrder();
			} else {
				this.code += e.key; // while this is not an 'enter' it stores the every key
			}

			// run a timeout of 200ms at the first read and clear everything
			// if (!this.isReading) {
			// 	this.isReading = true;
			// 	setTimeout(() => {
			// 		this.code = '';
			// 		this.isReading = false;
			// 	}, 200);  //200 works fine for me but you can adjust it
			// }
		},

		initBarcodeListener() {
			document.addEventListener('keypress', this.onBarcodeScan);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isUserCan: 'isUserCan',
			locale: 'locale',
			store: 'store',
		}),
		fetchParams() {
			const params = {
				status: this.status,
			};

			if (this.type === 'order_id') {
				params.order_id = this.q;
			} else if (this.type === 'receipt_number') {
				params.receipt_number = this.q;
			}

			if (this.status === 'broken') {
				params.evidence_url = this.evidenceUrl;
			}

			return params;
		},
		information() {
			const status = toTitleCase(this.status);
			const information = `Scan the Order ID, Reference ID or Receipt Number barcode, and the return status will be updated to ${status}`;
			return information;
		},
	},
	watch: {
		user() {
			this.onUserLoaded();
		},
		q(newValue) {
			this.code = newValue;
		},
	},
	created() {
		if (this.user) {
			this.onUserLoaded();
		}
	},
	destroyed() {
		document.removeEventListener('keypress', this.onBarcodeScan);
	},
	updated() {},
	directives: {
		focus: {
			// directive definition
			inserted(el) {
				el.focus();
			},
		},
	},
};
</script>
<style scoped>
.form-control-sm {
	height: calc(1.5em + 0.5rem + 2px) !important;
}
.barcode-info-scan {
	margin: -24px -24px 0 -24px;
}
.text-sm {
	font-size: 0.9em;
}
.barcode-list {
    border: 1px solid #ddd;
    border-top: 0;
    min-height: 100px;
    overflow-y: auto;
}
.barcode-list-table {
    margin-bottom: 1px;
    font-size: .9em;
}
.list-empty {
    padding: 2em 1em;
    font-size: 1.2em;
    text-align: center;
    background-color: #fff;
    border-radius: 3px;
    color: #b1b1b1;
}
</style>
